import { render, staticRenderFns } from "./NotificationPatientApprovalRequestForm.vue?vue&type=template&id=0dc4cca6"
import script from "./NotificationPatientApprovalRequestForm.vue?vue&type=script&lang=js"
export * from "./NotificationPatientApprovalRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports